import { render, staticRenderFns } from "./NewLandingTable.vue?vue&type=template&id=602997f4&scoped=true"
import script from "./NewLandingTable.vue?vue&type=script&lang=js"
export * from "./NewLandingTable.vue?vue&type=script&lang=js"
import style0 from "./NewLandingTable.vue?vue&type=style&index=0&id=602997f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602997f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('602997f4')) {
      api.createRecord('602997f4', component.options)
    } else {
      api.reload('602997f4', component.options)
    }
    module.hot.accept("./NewLandingTable.vue?vue&type=template&id=602997f4&scoped=true", function () {
      api.rerender('602997f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/NewLanding/NewLandingTable.vue"
export default component.exports